import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import fadliPng from '../assets/img/fadli3.jpg';

const Profile = React.memo(function Profile() {
  return (
    <div className="w-full lg:w-1/3 lg:rounded-bl-lg bg-white lg:border-r-2 border-slate-200 animate-fade-in lg:overflow-y-auto lg:h-full scrollbar-hide">
      <div className='flex flex-col justify-between h-full'>
        <div className="p-4 md:p-12 text-center lg:text-left">
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-gradient-primary rounded-full blur-md opacity-30 animate-pulse-glow"></div>
            <LazyLoadImage
              className="relative block rounded-full shadow-2xl mx-auto h-48 w-48 object-cover object-center border-4 border-white animate-float"
              src={fadliPng}
              srcSet={`${fadliPng} 1x`}
              alt="Acmad Fadli Aditama"
              effect="blur"
            />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold pt-8 text-gradient-primary">Acmad Fadli Aditama</h1>
          <div className="mx-auto lg:mx-0 w-4/5 pt-3 border-b-2 border-gradient-primary opacity-75"></div>
          <p className="pt-4 text-lg font-bold flex items-center justify-center lg:justify-start text-slate-700">
            <span className="inline-block w-2 h-2 bg-gradient-accent rounded-full mr-2 animate-pulse"></span>
            Front End Developer
          </p>
          <p className="pt-6 text-slate-600 leading-relaxed">
            Halo, saya adalah Web Developer dengan spesialisasi di bidang Front End Development. Dengan pengalaman menangani berbagai proyek web strategis, saya siap menghadapi tantangan baru untuk mengoptimalkan keahlian teknis saya.
          </p>
        </div>
        <div className="p-4 md:p-12 text-center lg:text-left sticky bg-white">
          <div className="mt-6 pb-6 pt-6 w-3/5 lg:w-full mx-auto flex flex-wrap items-center justify-between gap-4 px-4">
            <a href="https://github.com/fadliaditama" target="_blank" rel="noopener noreferrer" aria-label="Profil GitHub Acmad Fadli Aditama" className="link-hover inline-block text-slate-700 hover:text-blue-600 transition-all duration-300">
              <i className="fab fa-github fa-xl"></i>
            </a>
            <a href="https://www.linkedin.com/in/acmad-fadli-aditama/" target="_blank" rel="noopener noreferrer" aria-label="Profil LinkedIn Acmad Fadli Aditama" className="link-hover inline-block text-slate-700 hover:text-blue-600 transition-all duration-300">
              <i className="fa-brands fa-linkedin fa-xl"></i>
            </a>
            <a href="https://www.facebook.com/profadlibae/" target="_blank" rel="noopener noreferrer" aria-label="Profil Facebook Acmad Fadli Aditama" className="link-hover inline-block text-slate-700 hover:text-blue-600 transition-all duration-300">
              <i className="fab fa-facebook fa-xl"></i>
            </a>
            <a href="https://www.instagram.com/fadliaditama/" target="_blank" rel="noopener noreferrer" aria-label="Profil Instagram Acmad Fadli Aditama" className="link-hover inline-block text-slate-700 hover:text-blue-600 transition-all duration-300">
              <i className="fab fa-instagram fa-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Profile;
